import React from 'react'
import { Box } from 'pcln-design-system'
import { AppDownload } from '@pcln/vip'
import analytics from '@/shared-utils/analytics'
import LayoutComponentWrapper from '../LayoutComponentWrapper'

type AppDownloadWrapperProps = {
  category: string
}

function AppDownloadWrapper({
  category,
  ...props
}: AppDownloadWrapperProps & Record<string, unknown>) {
  const gaAppDownload = (device: string) => {
    analytics.fireEvent({
      action: 'app download',
      category,
      label: device
    })
  }

  return (
    <LayoutComponentWrapper>
      <Box
        color="background.light"
        boxShadowSize="sm"
        borderRadius="xl"
        pr={[3, null, null, null, 4, 5]}
        pl={4}
      >
        <AppDownload gaTracking={gaAppDownload} {...props} />
      </Box>
    </LayoutComponentWrapper>
  )
}

export default AppDownloadWrapper
